import type { GrammarExercise } from "./grammar.js";

export const MISC_EXERCISES: Record<string, GrammarExercise[]> = {
  "comparatives-superlatives": [
    {
      question: "This is ___ movie I have ever seen.",
      options: ["the most boring", "the boringest", "more boring", "most boring"],
      correctIndex: 0,
      explanationVi:
        "So sánh nhất với tính từ dài dùng 'the most + adj'; 'ever seen' là dấu hiệu của so sánh nhất.",
    },
    {
      question: "My new phone is much ___ than my old one.",
      options: ["fast", "faster", "more fast", "fastest"],
      correctIndex: 1,
      explanationVi:
        "'Than' là dấu hiệu của so sánh hơn; 'fast' là tính từ ngắn nên thêm -er, không dùng 'more fast'.",
    },
    {
      question: "Today is ___ hotter than yesterday, so let's stay inside.",
      options: ["very", "more", "most", "far"],
      correctIndex: 3,
      explanationVi:
        "Để nhấn mạnh so sánh hơn, dùng much/a lot/far + comparative (far hotter); 'very' không đứng trước dạng so sánh hơn.",
    },
    {
      question: "Her presentation was not as ___ as mine, but she got more questions.",
      options: ["good", "better", "best", "well"],
      correctIndex: 0,
      explanationVi:
        "Cấu trúc so sánh bằng 'as + adj + as' dùng tính từ ở dạng nguyên thể (as good as), không dùng dạng so sánh hơn.",
    },
    {
      question: "That is ___ restaurant in our neighborhood, so we go there every weekend.",
      options: ["better", "good", "the best", "best"],
      correctIndex: 2,
      explanationVi:
        "'In our neighborhood' giới hạn một nhóm để so sánh nên dùng so sánh nhất, và so sánh nhất cần 'the' phía trước: the best.",
    },
  ],
  "adjective-order": [
    {
      question: "She bought a ___ dress for the party.",
      options: ["red beautiful silk", "beautiful red silk", "silk beautiful red", "beautiful silk red"],
      correctIndex: 1,
      explanationVi:
        "Trật tự tính từ chuẩn: Opinion → Color → Material, nên 'beautiful (ý kiến) red (màu) silk (chất liệu)' là đúng.",
    },
    {
      question: "He lives in a ___ house near the lake.",
      options: ["old lovely stone", "stone lovely old", "lovely old stone", "lovely stone old"],
      correctIndex: 2,
      explanationVi:
        "Theo trật tự Opinion → Age → Material: 'lovely (ý kiến) old (tuổi) stone (chất liệu)' đứng trước danh từ.",
    },
    {
      question: "They gave me a ___ bag as a birthday present.",
      options: ["small black leather", "black small leather", "leather small black", "small leather black"],
      correctIndex: 0,
      explanationVi:
        "Trật tự đúng là Size → Color → Material: 'small (kích thước) black (màu) leather (chất liệu) bag'.",
    },
    {
      question: "We had dinner at a ___ restaurant near the office.",
      options: ["little nice", "nice and little", "little and nice", "nice little"],
      correctIndex: 3,
      explanationVi:
        "Tính từ chỉ ý kiến (nice) luôn đứng trước tính từ chỉ kích thước (little) theo trật tự Opinion → Size.",
    },
    {
      question: "My uncle drives a ___ car to work every day.",
      options: ["German blue new", "blue new German", "new blue German", "new German blue"],
      correctIndex: 2,
      explanationVi:
        "Theo trật tự Age → Color → Origin: 'new (tuổi) blue (màu) German (nguồn gốc)' là thứ tự đúng trước danh từ.",
    },
  ],
  "so-such-too-enough": [
    {
      question: "The meeting was ___ long that everyone got tired.",
      options: ["so", "such", "such a", "too"],
      correctIndex: 0,
      explanationVi:
        "Trước tính từ đứng một mình (long) và có mệnh đề 'that' phía sau, dùng 'so + adj + that'; 'such' cần danh từ đi kèm.",
    },
    {
      question: "It was ___ interesting presentation that nobody left early.",
      options: ["so", "so an", "such an", "too"],
      correctIndex: 2,
      explanationVi:
        "Có danh từ 'presentation' phía sau nên dùng 'such + a/an + adj + noun'; 'interesting' bắt đầu bằng nguyên âm nên dùng 'an'.",
    },
    {
      question: "This box is ___ heavy for me to carry alone.",
      options: ["enough", "so", "such", "too"],
      correctIndex: 3,
      explanationVi:
        "Cấu trúc 'too + adj + (for someone) + to V' mang nghĩa tiêu cực: quá nặng đến mức không thể tự mang được.",
    },
    {
      question: "He isn't experienced ___ to lead the project yet.",
      options: ["too", "enough", "so", "such"],
      correctIndex: 1,
      explanationVi:
        "'Enough' đứng SAU tính từ trong cấu trúc 'adj + enough + to V' (đủ kinh nghiệm để làm gì).",
    },
    {
      question: "We don't have ___ to finish the report today.",
      options: ["enough time", "time enough", "too time", "so time"],
      correctIndex: 0,
      explanationVi:
        "Khi đi với danh từ, 'enough' đứng TRƯỚC danh từ (enough time); nó chỉ đứng sau tính từ/trạng từ.",
    },
  ],
  adverbs: [
    {
      question: "He ___ coffee in the evening because he can't sleep.",
      options: ["drinks never", "never drinks", "is never drink", "never drink"],
      correctIndex: 1,
      explanationVi:
        "Trạng từ tần suất (never) đứng TRƯỚC động từ thường; chủ ngữ 'he' nên động từ chia 'drinks'.",
    },
    {
      question: "She sings very ___ , so everyone loves her performances.",
      options: ["beautiful", "beauty", "beautifully", "more beautiful"],
      correctIndex: 2,
      explanationVi:
        "Bổ nghĩa cho động từ 'sings' phải dùng trạng từ cách thức: tính từ + -ly (beautiful → beautifully).",
    },
    {
      question: "He works very ___ , so his boss trusts him with big projects.",
      options: ["hard", "hardly", "harder", "hardest"],
      correctIndex: 0,
      explanationVi:
        "'Hard' vừa là tính từ vừa là trạng từ (làm việc chăm chỉ); 'hardly' là trạng từ khác nghĩa hoàn toàn (hầu như không).",
    },
    {
      question: "My grandmother speaks English quite ___ for her age.",
      options: ["good", "goodly", "best", "well"],
      correctIndex: 3,
      explanationVi:
        "Trạng từ của 'good' là dạng bất quy tắc 'well'; bổ nghĩa cho động từ 'speaks' nên phải dùng trạng từ, không dùng tính từ 'good'.",
    },
    {
      question: "She drives too ___ on the highway, and it worries me.",
      options: ["fastly", "fast", "quick", "fastest"],
      correctIndex: 1,
      explanationVi:
        "'Fast' là trạng từ bất quy tắc, giữ nguyên dạng khi bổ nghĩa cho động từ; không tồn tại 'fastly', còn 'quick' là tính từ.",
    },
  ],
  "prepositions-time": [
    {
      question: "The meeting starts ___ 9:30, so please don't be late.",
      options: ["at", "on", "in", "from"],
      correctIndex: 0,
      explanationVi:
        "Trước giờ giấc cụ thể (9:30) luôn dùng 'at'; 'on' dùng cho ngày và 'in' dùng cho tháng/năm.",
    },
    {
      question: "My birthday is ___ October, near the end of the month.",
      options: ["at", "on", "in", "to"],
      correctIndex: 2,
      explanationVi:
        "Trước tháng (October) dùng 'in'; 'on' chỉ dùng khi có ngày cụ thể như 'on October 20th'.",
    },
    {
      question: "We have a team lunch ___ Fridays.",
      options: ["in", "on", "at", "by"],
      correctIndex: 1,
      explanationVi:
        "Trước ngày trong tuần (Fridays) dùng 'on'; số nhiều 'Fridays' nghĩa là vào các thứ Sáu hằng tuần.",
    },
    {
      question: "She's moving to a new apartment ___ next month.",
      options: ["in", "on", "at", "no preposition"],
      correctIndex: 3,
      explanationVi:
        "Không dùng giới từ trước next/last/this/every + thời gian: nói 'next month', không nói 'in next month'.",
    },
    {
      question: "He often works ___ night when the office is quiet.",
      options: ["in", "on", "at", "by"],
      correctIndex: 2,
      explanationVi:
        "'At night' là cụm cố định với 'at'; lưu ý khác với 'in the morning/afternoon/evening' dùng 'in'.",
    },
  ],
  "prepositions-place": [
    {
      question: "Your glasses are ___ the kitchen table, next to the newspaper.",
      options: ["in", "on", "at", "under"],
      correctIndex: 1,
      explanationVi:
        "Vật nằm trên bề mặt (mặt bàn) dùng 'on'; 'in' chỉ dùng cho không gian kín như hộp, phòng.",
    },
    {
      question: "Let's meet ___ the main entrance after work.",
      options: ["at", "in", "on", "into"],
      correctIndex: 0,
      explanationVi:
        "'At' dùng cho một điểm gặp cụ thể (cổng chính, trạm xe buýt); không nói 'in the entrance' khi chỉ điểm hẹn.",
    },
    {
      question: "She walked ___ the office and said hello to everyone.",
      options: ["to", "at", "on", "into"],
      correctIndex: 3,
      explanationVi:
        "'Into' diễn tả chuyển động đi vào bên trong một không gian; 'to' chỉ hướng đến đích nhưng không nhấn mạnh việc vào trong.",
    },
    {
      question: "My parents live ___ a small town near Da Lat.",
      options: ["at", "on", "in", "to"],
      correctIndex: 2,
      explanationVi:
        "Với thành phố, thị trấn, quốc gia dùng 'in' (in a town, in Vietnam); 'at' chỉ dùng cho địa chỉ/điểm cụ thể.",
    },
    {
      question: "The pharmacy is ___ the bank and the coffee shop.",
      options: ["among", "between", "beside", "under"],
      correctIndex: 1,
      explanationVi:
        "'Between' dùng khi ở giữa HAI đối tượng (the bank and the coffee shop); 'among' dùng khi ở giữa nhiều hơn hai.",
    },
  ],
  conjunctions: [
    {
      question: "___ it was raining, we went for a walk in the park.",
      options: ["Because", "Although", "So", "Unless"],
      correctIndex: 1,
      explanationVi:
        "Hai mệnh đề tương phản nhau (trời mưa >< vẫn đi dạo) nên dùng 'although' để diễn tả sự nhượng bộ; 'because' nêu lý do sẽ sai nghĩa.",
    },
    {
      question: "I won't go to the party ___ you come with me.",
      options: ["if", "because", "unless", "although"],
      correctIndex: 2,
      explanationVi:
        "'Unless' = 'if...not': tôi sẽ không đi trừ khi bạn đi cùng. Dùng 'if' ở đây sẽ ngược nghĩa với ý câu.",
    },
    {
      question: "He was hungry, ___ he made himself a sandwich.",
      options: ["so", "because", "but", "or"],
      correctIndex: 0,
      explanationVi:
        "Mệnh đề sau là KẾT QUẢ của mệnh đề trước (đói → làm bánh mì) nên dùng 'so'; 'because' dùng khi mệnh đề sau là nguyên nhân.",
    },
    {
      question: "She stayed home from work ___ she had a fever.",
      options: ["although", "but", "or", "because"],
      correctIndex: 3,
      explanationVi:
        "Mệnh đề sau nêu LÝ DO trực tiếp (bị sốt) cho hành động ở trước, nên dùng liên từ phụ thuộc 'because'.",
    },
    {
      question: "Hurry up, ___ we will miss the last train.",
      options: ["and", "or", "but", "so"],
      correctIndex: 1,
      explanationVi:
        "Sau câu mệnh lệnh, 'or' mang nghĩa 'nếu không thì' (Nhanh lên, nếu không chúng ta sẽ lỡ tàu).",
    },
  ],
  "yes-no-questions": [
    {
      question: "___ your sister work at the bank downtown?",
      options: ["Do", "Does", "Is", "Are"],
      correctIndex: 1,
      explanationVi:
        "Động từ thường 'work' ở Present Simple với chủ ngữ số ít 'your sister' cần trợ động từ 'Does' đảo lên trước, và động từ giữ nguyên thể.",
    },
    {
      question: "___ they go to the cinema last night?",
      options: ["Do", "Does", "Did", "Were"],
      correctIndex: 2,
      explanationVi:
        "'Last night' là dấu hiệu Past Simple; câu hỏi với động từ thường dùng 'Did + S + V nguyên thể' (go, không phải went).",
    },
    {
      question: "___ you ever been to Singapore?",
      options: ["Have", "Do", "Did", "Are"],
      correctIndex: 0,
      explanationVi:
        "'Ever' và 'been' (V3) là dấu hiệu của Present Perfect, nên đảo trợ động từ 'Have' lên trước chủ ngữ.",
    },
    {
      question: "___ he coming to the meeting this afternoon?",
      options: ["Does", "Do", "Are", "Is"],
      correctIndex: 3,
      explanationVi:
        "'Coming' (V-ing) cho biết đây là Present Continuous, nên đảo 'to be' lên trước; chủ ngữ 'he' đi với 'Is', không dùng do/does.",
    },
    {
      question: "Can your brother swim? — Yes, he ___.",
      options: ["does", "swims", "is", "can"],
      correctIndex: 3,
      explanationVi:
        "Câu trả lời ngắn lặp lại đúng trợ động từ của câu hỏi: hỏi bằng 'Can' thì trả lời 'Yes, he can', không dùng 'does'.",
    },
  ],
  "wh-questions": [
    {
      question: "Who ___ you the news about the new manager?",
      options: ["did tell", "told", "did told", "tell"],
      correctIndex: 1,
      explanationVi:
        "Khi 'Who' làm CHỦ NGỮ của câu hỏi thì không đảo ngữ, không thêm did — động từ chia thì quá khứ bình thường: Who told you...?",
    },
    {
      question: "___ sugar do you want in your tea?",
      options: ["How many", "How long", "How much", "How often"],
      correctIndex: 2,
      explanationVi:
        "'Sugar' là danh từ không đếm được nên hỏi số lượng bằng 'how much'; 'how many' chỉ dùng với danh từ đếm được.",
    },
    {
      question: "___ do you visit your grandparents? — About once a month.",
      options: ["How long", "How often", "How much", "How far"],
      correctIndex: 1,
      explanationVi:
        "Câu trả lời 'once a month' chỉ TẦN SUẤT, nên câu hỏi phải là 'how often' (bao lâu một lần), không phải 'how long' (kéo dài bao lâu).",
    },
    {
      question: "Where ___ on your vacation last summer?",
      options: ["you traveled", "did you traveled", "you did travel", "did you travel"],
      correctIndex: 3,
      explanationVi:
        "Câu hỏi Wh- với động từ thường ở Past Simple theo công thức 'Wh-word + did + S + V nguyên thể'; sau 'did' động từ không chia quá khứ.",
    },
    {
      question: "___ umbrella is this? Someone left it in the meeting room.",
      options: ["Whose", "Which", "What", "Who"],
      correctIndex: 0,
      explanationVi:
        "Hỏi về sự SỞ HỮU (cái ô của ai) dùng 'whose + danh từ'; 'who' hỏi về người nhưng không đứng trước danh từ như vậy.",
    },
  ],
  negation: [
    {
      question: "She ___ eat meat; she's been vegetarian for years.",
      options: ["doesn't", "don't", "isn't", "not"],
      correctIndex: 0,
      explanationVi:
        "Phủ định động từ thường ở Present Simple dùng do/does + not; chủ ngữ 'she' số ít nên dùng 'doesn't', sau đó là V nguyên thể.",
    },
    {
      question: "They ___ finished the project yet, so the deadline was extended.",
      options: ["don't", "didn't", "haven't", "aren't"],
      correctIndex: 2,
      explanationVi:
        "'Yet' và 'finished' (V3) là dấu hiệu của Present Perfect; phủ định bằng cách thêm 'not' sau trợ động từ have: haven't finished.",
    },
    {
      question: "I didn't say ___ about the plan during the meeting.",
      options: ["nothing", "anything", "something", "none"],
      correctIndex: 1,
      explanationVi:
        "Câu đã có 'didn't' nên phải dùng 'anything' để tránh phủ định kép; 'didn't...nothing' sai trong tiếng Anh chuẩn.",
    },
    {
      question: "He ___ at work yesterday because he was sick.",
      options: ["isn't", "didn't", "doesn't", "wasn't"],
      correctIndex: 3,
      explanationVi:
        "'Yesterday' cho biết thì quá khứ, và câu dùng 'to be' (at work) nên phủ định là 'wasn't', không cần trợ động từ did.",
    },
    {
      question: "I ___ like vegetables when I was a child, but now I love them.",
      options: ["don't", "wasn't", "didn't", "am not"],
      correctIndex: 2,
      explanationVi:
        "'When I was a child' là dấu hiệu Past Simple; phủ định động từ thường 'like' dùng 'didn't + V nguyên thể', không dùng 'wasn't'.",
    },
  ],
};
